import { Injectable } from '@angular/core';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { InviteCreationOptions } from '../../../../../../../../common/src/options/invite-creation.options';

@Injectable()
export class EmployeeInviteFormFactory {
  constructor(private readonly formFactory: FormFactory) {
  }

  create(): AdvancedForm<InviteCreationOptions> {
    return this.formFactory.create(new InviteCreationOptions(), [new AdvancedFormButton('SAVE', ButtonStyleEnum.Primary, 'Continue', ButtonTypeEnum.Submit)]);
  }
}
